import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";
import UFOSegment from "@atlaskit/react-ufo/segment";
import { token } from "@atlaskit/tokens";

import { ContentBlock, EmbeddedVideo } from "@/libraries/design/components";
import { wacToken } from "@/libraries/design/foundations";
import { SECTION_DIVIDER_HEIGHTS } from "@/libraries/design/utils";
import { Row } from "@/libraries/wpl/foundations/src";

export const RovoInnovationsVideo = () => {
    const intl = useIntl();

    return (
        <UFOSegment name="homepage-rovo-innovations-video">
            <section css={mainSectionStyles}>
                <div css={contentSectionStyles}>
                    <Row layout="8">
                        <ContentBlock
                            title={intl.formatMessage({
                                id: "HomePageTemplateV2.RovoInnovationVideo.Title",
                                defaultMessage:
                                    "The latest AI innovations from Atlassian"
                            })}
                            text={intl.formatMessage({
                                id: "HomePageTemplateV2.RovoInnovationVideo.Text",
                                defaultMessage:
                                    "See how Rovo powers real teamwork by embedding AI agents into your tools and workflows so teams can move their most critical work forward, together."
                            })}
                            callToActionProps={{
                                link: {
                                    text: intl.formatMessage({
                                        id: "HomePageTemplateV2.RovoInnovationVideo.CTA",
                                        defaultMessage: "Learn more"
                                    }),
                                    href: "/blog/ai/rovo-ai-agents-at-work"
                                }
                            }}
                            alignment="center"
                        />
                    </Row>
                </div>
                <div css={videoSectionStyles}>
                    <Row layout="10">
                        <EmbeddedVideo // both of the asset urls are placeholders and will be replaced by finals provided on 2/24
                            embedUrl="https://www.youtube.com/embed/emidrJeUTaM?si=NMdZ32OecmeHKhyj"
                            title="" // will be added once final video is provided
                            thumbnail={{
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/a4r57ccpa6s85we0da21h55nai83253k.png",
                                alt: ""
                            }}
                        />
                    </Row>
                </div>
            </section>
        </UFOSegment>
    );
};

RovoInnovationsVideo.displayName = "RovoInnovationsVideo";

const mainSectionStyles = css({
    marginBlock: token("space.800")
});

const contentSectionStyles = css({
    backgroundColor: wacToken("color.extended.purple200"),
    paddingBlockStart: token("space.800"),
    paddingBlockEnd: token("space.400")
});

const videoSectionStyles = css({
    position: "relative",
    ["::before"]: {
        content: "",
        backgroundColor: wacToken("color.extended.purple200"),
        width: "100%",
        display: "block",
        position: "absolute",
        zIndex: "-1",
        height: "50%",
        paddingBlockEnd: "0.25px" // to address occasionally visible white line/gap
    },
    ["::after"]: {
        content: "",
        backgroundColor: wacToken("color.extended.purple200"),
        width: "100%",
        display: "block",
        position: "absolute",
        zIndex: "-1",
        insetBlockStart: "50%",
        clipPath: "polygon(0 100%, 100% 0, 0 0)",
        height: `${SECTION_DIVIDER_HEIGHTS.mobile}px`,
        [media.above.sm]: {
            height: `${SECTION_DIVIDER_HEIGHTS.tablet}px`
        },
        [media.above.md]: {
            height: `${SECTION_DIVIDER_HEIGHTS.desktop}px`
        }
    }
});
